import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(1, 0),
		color: theme.palette.brand,
		// fontSize: 20,
		fontWeight: 600,
		[theme.breakpoints.up("sm")]: {
			minWidth: 140,
		},
	},
	branded: {
		color: theme.palette.brand,
		background: theme.palette.highlight,
		borderColor: theme.palette.highlight,
		"&:hover": {
			background: "#c1c72c",
			borderColor: "#c1c72c",
		},
	},
	content: {
		margin: `0 32px`,
	},
	loading: {
		position: "relative",
		"&::after": {
			content: '" "',
			display: "block",
			position: "absolute",
			left: -25,
			top: 2,
			width: 12,
			height: 12,
			margin: 3,
			borderRadius: "50%",
			border: `1px solid ${theme.palette.brand}`,
			borderColor: `${theme.palette.brand} transparent ${theme.palette.brand} transparent`,
			animation: `$spinner 1.2s linear infinite`,
		},
	},
	[`@keyframes spinner`]: {
		"0%": {
			transform: "rotate(0deg)",
		},
		"100%": {
			transform: "rotate(360deg)",
		},
	},
}));

const FormButton = ({
	children,
	className,
	color,
	loading,
	onClick,
	...props
}) => {
	const branded = color === "brand";
	const classes = useStyles();
	const classNames = clsx(
		classes.root,
		branded ? classes.branded : "",
		className
	);

	return (
		<Button
			color="primary"
			className={classNames}
			size="small"
			variant="outlined"
			onClick={onClick}
			{...props}
		>
			<span
				className={clsx(
					classes.content,
					loading ? classes.loading : ""
				)}
			>
				{children}
			</span>
		</Button>
	);
};

FormButton.propTypes = {
	children: PropTypes.string.isRequired,
	className: PropTypes.string,
	color: PropTypes.string,
	loading: PropTypes.bool,
	onClick: PropTypes.func.isRequired,
};

export default FormButton;
